<h2 mat-dialog-title class="pr-0 pb-0 mb-0">Capture Screen {{form.controls['reference'].value ? ' - ' +
    form.controls['reference'].value : ''}}

    <!-- Close button -->
    <button mat-icon-button (click)="confirmCloseIfDirty()" class="float-right">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <mat-stepper class="mt-2 h-100" [orientation]="(stepperOrientation | async)!" [linear]="!isReadMode"
        labelPosition="bottom" [selectedIndex]="currentStep" (selectedIndexChange)="onStep($event)" #stepper>
 
        <mat-step [stepControl]="customerForm" label="Customer Information" errorMessage="Incorrect Details."
            state="valid">
            <form [formGroup]="customerForm">
                <h2>Customer Information
                    <mat-icon [@fadeInOut] class="valid-icon"
                        *ngIf="customerForm.status === 'VALID'">check_circle</mat-icon>
                </h2>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>ID Type</mat-label>
                        @if (isReadMode) {
                        <input matInput readonly [value]="toIdType(customerForm.get('identityType')?.value)">
                        } @else {
                        <mat-select formControlName="identityType" required
                            (selectionChange)="changeFocusToAndAnimation(customerIdInput);">
                            @for (opt of idTypeOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{opt.display}}</mat-option>
                            }
                        </mat-select>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>ID Field</mat-label>
                        <input matInput type="text" formControlName="identityNumber" required [readonly]="isReadMode"
                            #customerIdInput>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Title</mat-label>
                        @if (isReadMode) {
                        <input matInput readonly="true" [value]="toTitle(customerForm.get('title')?.value)">
                        } @else {
                        <mat-select formControlName="title">
                            @for (opt of titleOptions; track opt) {
                            <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                            }
                        </mat-select>
                        }
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Surname</mat-label>
                        <input matInput formControlName="lastName" required [readonly]="isReadMode">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Names</mat-label>
                        <input matInput formControlName="firstName" required [readonly]="isReadMode">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Marital Status</mat-label>
                        @if (isReadMode) {
                        <input matInput readonly [value]="toMaterialStatus(customerForm.get('maritalStatus')?.value)">
                        } @else {
                        <mat-select formControlName="maritalStatus">
                            @for (status of maritalStatuses; track status.value) {
                            <mat-option [value]="status.value">{{ status.display }}</mat-option>
                            }
                        </mat-select>
                        }
                    </mat-form-field>
                </div>

                <h3>Contact Information</h3>
                <div class="flex-row flex-wrap">

                    <!-- Validation: Valid email format.  -->
                    <mat-form-field appearance="outline">
                        <mat-label>Email Address</mat-label>
                        <input matInput type="email" formControlName="email" required [readonly]="isReadMode">
                        <mat-icon matSuffix>mail</mat-icon>
                    </mat-form-field>

                    <!-- Can be in format +27 (xx) xxx-xxxx -->
                    <mat-form-field appearance="outline">
                        <mat-label>Mobile Number</mat-label>
                        <input formControlName="mobileNumber" placeholder="Formatting is automatic" type="tel"
                            libPhoneFormat matInput required [control]="customerForm.controls['mobileNumber']"
                            [readonly]="isReadMode">
                        <mat-icon matSuffix>phone</mat-icon>
                        <mat-hint>Format: +27 (xx) xxx-xxxx</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Postal Code</mat-label>
                        <input matInput formControlName="postalCode" [readonly]="isReadMode">
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6"
                            formControlName="address" [readonly]="isReadMode"></textarea>
                    </mat-form-field>
                </div>

                <mat-slide-toggle class="ml-3" [checked]="isCustomerAPatient" [disabled]="isReadMode"
                    [color]="isReadMode ? 'primary' : 'accent'" (change)="onTogglePatientSameAsCustomer($event)">Is the
                    patient the same as the customer?</mat-slide-toggle>

            </form>

            <div class="stepper-controls">
                <button mat-stroked-button type="button"
                    [matTooltip]="customerForm.valid || isReadMode ? '' : 'Please complete the required fields.'"
                    (click)="customerForm.valid || isReadMode ? '' : markFormAtStepTouched()"
                    matStepperNext color="primary">
                    <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next</button>
            </div>
        </mat-step>

        <mat-step [stepControl]="employmentForm" label="Employment Information" errorMessage="Incorrect Details."
            state="valid">

            <ng-template matStepContent>

            <form [formGroup]="employmentForm">
                <h2>Employment Information
                    <mat-icon [@fadeInOut] class="valid-icon"
                        *ngIf="employmentForm.status === 'VALID'">check_circle</mat-icon>
                </h2>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Employer</mat-label>
                        <input matInput formControlName="employer" required [readonly]="isReadMode">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Branch</mat-label>
                        <input matInput formControlName="employerBranch" [readonly]="isReadMode">
                    </mat-form-field>

                    <lib-year-month-picker [readonly]="isReadMode" [hint]="''"
                        [formControl]="employmentForm.controls['employmentStartDate']"></lib-year-month-picker>
                </div>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Employer Branch Ph. Number</mat-label>
                        <input formControlName="employerTelephone" libPhoneFormat matInput
                            placeholder="Formatting is automatic" required type="tel"
                            [control]="employmentForm.controls['employerTelephone']" [readonly]="isReadMode">
                        <mat-icon matSuffix>phone</mat-icon>
                        <mat-hint>Format: +27 (xx) xxx-xxxx</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Job Title</mat-label>
                        <input matInput formControlName="designation" [readonly]="isReadMode">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Employee Number</mat-label>
                        <input matInput formControlName="employeeNumber" [readonly]="isReadMode">
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Pay Cycle</mat-label>
                        @if (isReadMode) {
                        <input matInput readonly [value]="toPayCycle(employmentForm.get('payCycleId')?.value)">
                        } @else {
                        <mat-select formControlName="payCycleId" required
                            (selectionChange)="changeFocusToAndAnimation('payDateInput');">
                            @for (opt of payCyclesOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{opt.display}}</mat-option>
                            }
                        </mat-select>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Pay Date</mat-label>

                        @if (isReadMode) {
                        <input matInput readonly required [value]="toPayDate(employmentForm.get('payDay')?.value)">
                        } @else {
                        <!-- Monthly paid is 1-31 or Last Day.  -->
                        @if (employmentForm.get('payCycleId')?.value === 7) {
                        <mat-select formControlName="payDay" required name="payDateInput">
                            @for (opt of monthlyPayDateOptions; track opt) {
                            <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                            }
                        </mat-select>
                        } @else {
                        <!-- Weekly and fortnightly is the day of the week. Monday-Sunday.  -->
                        <mat-select formControlName="payDay" required name="payDateInput">
                            @for (opt of weeklyPayDateOptions; track opt) {
                            <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                            }
                        </mat-select>
                        }
                        }

                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Postal Code</mat-label>
                        <input matInput formControlName="employerPostalCode" [readonly]="isReadMode">
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6"
                            formControlName="employerAddress" [readonly]="isReadMode"></textarea>
                    </mat-form-field>
                </div>

            </form>

            <div class="stepper-controls">
                <button mat-stroked-button type="button"
                    [matTooltip]="employmentForm.valid || isReadMode ? '' : 'Please complete the required fields.'"
                    (click)="employmentForm.valid || isReadMode ? '' : markFormAtStepTouched()"
                    matStepperNext color="primary">
                    <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next
                </button>
                
                <button mat-stroked-button type="button" matStepperPrevious>
                    <mat-icon>arrow_back_ios</mat-icon> Back
                </button>
            </div>
            </ng-template>

        </mat-step>

        <mat-step [stepControl]="patientStepperForm" label="Patient(s) Information" errorMessage="Incorrect Details."
            state="valid">
            
            <ng-template matStepContent>

            <form [formGroup]="form">

                <h2>Patient(s) Information
                    <mat-icon [@fadeInOut] class="valid-icon"
                        *ngIf="patientStepperForm.status === 'VALID'">check_circle</mat-icon>
                    <mat-progress-bar mode="indeterminate" *ngIf="showPatientLoader" color="accent"></mat-progress-bar>
                </h2>

                <mat-slide-toggle class="ml-3 mb-2" [checked]="isCustomerAPatient" [disabled]="isReadMode"
                    [color]="isReadMode ? 'primary' : 'accent'" (change)="onTogglePatientSameAsCustomer($event)">Is the
                    patient the same as the customer?</mat-slide-toggle>

                <ng-container formArrayName="patients">
                    <mat-accordion class="headers-align" multi>
                        @for (patientForm of isCustomerAPatient ? patientsArray.controls : patientsArrayWithoutCustomer;
                        track patientForm.value;
                        let i = $index
                        ) {
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>

                                <mat-panel-title>({{i + 1}}) {{toTitle(patientForm.get('title')?.value)}}
                                    {{patientForm.get('lastName')?.value || ''}}</mat-panel-title>

                                <mat-panel-description>{{patientForm.get('firstName')?.value || ''}}&nbsp;

                                    @if (!isReadMode && (!isCustomerAPatient || isCustomerAPatient && i > 0)) {
                                    <button
                                        mat-icon-button type="button"
                                        [disabled]="showPatientLoader"
                                        (click)="deletePatient(i, patientForm); $event.stopPropagation();">
                                        <mat-icon color="warn">delete_forever</mat-icon>
                                    </button>
                                    }
                                </mat-panel-description>

                            </mat-expansion-panel-header>

                            <ng-container
                                *ngTemplateOutlet="patientsFormTemplate; context:{$implicit:patientForm}"></ng-container>
                        </mat-expansion-panel>
                        }

                    </mat-accordion>
                </ng-container>
            </form>

            @if (!isReadMode) {
            <button mat-raised-button [disabled]="showPatientLoader" (click)="addPatient()">
                Add Patient <mat-icon color="primary">add_circle</mat-icon>
            </button>
            }

            <div class="stepper-controls">
                <button mat-stroked-button type="button"
                    [matTooltip]="patientStepperForm.valid || isReadMode ? '' : patientErrorMessage()"
                    (click)="patientStepperForm.valid || isReadMode ? '' : markFormAtStepTouched()"
                    matStepperNext color="primary">
                    <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next
                </button>
                <button mat-stroked-button type="button" matStepperPrevious>
                    <mat-icon>arrow_back_ios</mat-icon> Back
                </button>
            </div>
            </ng-template>

        </mat-step>

        <mat-step [stepControl]="bankForm" label="Bank Information" errorMessage="Incorrect Details." state="valid">
            <ng-template matStepContent>

            <form [formGroup]="bankForm">
                <h2>Bank Information
                    <mat-icon [@fadeInOut] class="valid-icon"
                        *ngIf="bankForm.status === 'VALID'">check_circle</mat-icon>
                    <mat-progress-bar mode="indeterminate" *ngIf="showAccountHolderLoader || bankForm.status === 'PENDING'" color="accent"></mat-progress-bar>
                </h2>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Bank</mat-label>
                        @if (isReadMode) {
                        <input matInput readonly [value]="toBank(bankForm.get('bankId')?.value)">
                        } @else {
                        <mat-select formControlName="bankId" required (selectionChange)="onBankChange($event)">
                            @for (opt of bankOptions; track opt.name) {
                            <mat-option [value]="opt.id">{{ opt.name }}</mat-option>
                            }
                        </mat-select>
                        }
                        <mat-error *ngIf="bankForm.controls['bankId']?.errors?.['pleaseCheck']">Invalid - Please check.</mat-error>
                    </mat-form-field>

                    <!-- Populated automatically when selecting a bank. -->
                    <mat-form-field appearance="outline">
                        <mat-label>Branch Code</mat-label>
                        <input matInput formControlName="branchCode" required readonly>
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Account Type</mat-label>
                        @if (isReadMode) {
                        <input matInput readonly [value]="toAccountType(bankForm.get('bankAccountType')?.value)">
                        } @else {
                        <mat-select formControlName="bankAccountType" required (selectionChange)="removePleaseCheckValidator()">
                            @for (opt of bankAccountTypeOptions; track opt.value) {
                            <mat-option [value]="opt.value" [disabled]="opt.isDisabled">{{ opt.display }}</mat-option>
                            }
                        </mat-select>
                        }
                        @if(bankForm.get('bankAccountType')?.errors?.['pleaseCheck']) {
                        <mat-error>Invalid - Please check.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Account Number</mat-label>
                        <input matInput formControlName="bankAccountNumber" required [readonly]="isReadMode" (keyup)="onAccountNumberKeyUp()">
                        @if(bankForm.get('bankAccountNumber')?.errors?.['pleaseCheck']) {
                        <mat-error>Invalid - Please Check.</mat-error>
                        } @else if(bankForm.get('bankAccountNumber')?.errors?.['minlength']) {
                        <mat-error>Minimum length is 7.</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="form-error-message"
                    *ngIf="bankForm.errors?.['invalidBankDetails'] && (bankForm.touched || bankForm.dirty) && !isReadMode"
                    [@slideFadeInOut]="{value: ':enter', params: { height: '54px' }}">
                    The bank account number is invalid, please re-enter the correct account number. Note that  applications with invalid bank account details cannot be considered.
                    <button mat-flat-button (click)="retryBankValidation()">Try
                        again<mat-icon>sync_problem</mat-icon></button>
                </div>

                <mat-slide-toggle class="ml-3 mb-3" [disabled]="showAccountHolderLoader" [checked]="isCustomerTheAccountHolder" [disabled]="isReadMode"
                    [color]="isReadMode ? 'primary' : 'accent'"
                    (change)="onToggleAccountHolderSameAsCustomer($event)">Does the bank account belong to the customer?
                </mat-slide-toggle>

                @if (!isCustomerTheAccountHolder) {
                <div class="flex-row flex-wrap">
                    <!-- Account holder first name -->
                    <mat-form-field appearance="outline">
                        <mat-label>Account Holder First Name</mat-label>
                        <input matInput formControlName="accountHolderFirstName" required [readonly]="isReadMode">
                    </mat-form-field>

                    <!-- Account holder last name -->
                    <mat-form-field appearance="outline">
                        <mat-label>Account Holder Last Name</mat-label>
                        <input matInput formControlName="accountHolderLastName" required [readonly]="isReadMode">
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">
                    <!-- Account holder ID type -->
                    <mat-form-field appearance="outline">
                        <mat-label>Account Holder ID Type</mat-label>
                        <mat-select formControlName="accountHolderIdentityType" required>
                            @for (opt of idTypeOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <!-- Account holder ID -->
                    <mat-form-field appearance="outline">
                        <mat-label>Account Holder ID</mat-label>
                        <input matInput formControlName="accountHolderIdentityNumber" required [readonly]="isReadMode">
                        @if(bankForm.get('accountHolderIdentityNumber')?.hasError('sameAsCustomerId') && !isReadMode) {
                            <mat-error>Account holder ID cannot be the same as customer ID. If the Account Holder <strong>is</strong> the Customer, un-toggle this section.</mat-error>
                        }
                    </mat-form-field>
                </div>
                }

            </form>

            <div class="stepper-controls">
                <button mat-stroked-button type="button"
                    [matTooltip]="bankForm.valid || isReadMode? '' : 'Please complete the required fields.'"
                    (click)="bankForm.valid || isReadMode ? '' : markFormAtStepTouched()"
                    matStepperNext color="primary">
                    <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next
                </button>
                <button mat-stroked-button type="button" matStepperPrevious>
                    <mat-icon>arrow_back_ios</mat-icon> Back
                </button>
            </div>
            </ng-template>
        </mat-step>

        <mat-step [stepControl]="loanForm" label="Loan Information" errorMessage="Incorrect Details." state="valid">
            <ng-template matStepContent>

            <form [formGroup]="loanForm">
                <h2>Loan Information
                    <mat-icon [@fadeInOut] class="valid-icon"
                        *ngIf="loanForm.status === 'VALID'">check_circle</mat-icon>
                    <mat-progress-bar mode="indeterminate" *ngIf="showLoanLoader" color="accent"></mat-progress-bar>
                </h2>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Amount</mat-label>
                        <input matInput formControlName="loanAmount" required [readonly]="isReadMode" currencyMask>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>No. of Installments</mat-label>
                        @if (isReadMode) {
                        <input matInput type="number" formControlName="instalments" readonly>
                        } @else {
                        <mat-select formControlName="instalments" required>
                            @for (opt of installmentOptions(employmentForm.get('payCycleId')?.value); track opt) {
                            <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                            }
                        </mat-select>
                        }
                        <mat-hint>{{
                            installmentOptions(employmentForm.get('payCycleId')?.value).length > 0
                            ? '1 - ' + installmentOptions(employmentForm.get('payCycleId')?.value).length + '
                            installments.'
                            : ''
                        }}</mat-hint>
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">

                    @if (isReadMode) {
                    <mat-form-field appearance="outline">
                        <mat-label>Start Date</mat-label>
                        <input matInput readonly
                            [value]="form.controls['loan'].get('startDate')?.value | date:'dd/MM/yyyy'">
                    </mat-form-field>
                    } @else {

                    <mat-form-field appearance="outline">
                        <mat-label>Start Date</mat-label>
                        <mat-select formControlName="startDate" required>
                            @for (opt of loanStartDateOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    }

                    <mat-form-field appearance="outline">
                        <mat-label>Initiation Fee</mat-label>
                        <input matInput currencyMask formControlName="initiationFee" readonly>
                    </mat-form-field>
                </div>

                <div class="flex-row flex-wrap">
                    <mat-form-field appearance="outline">
                        <mat-label>Administration Fee (Per Month)</mat-label>
                        <input matInput currencyMask formControlName="administrationFee" readonly>
                    </mat-form-field>

                    @if (showLoanLoader) {
                    <mat-form-field appearance="outline">
                        <mat-label>Calculating Instalment...</mat-label>
                        <input matInput currencyMask disabled>
                        <mat-spinner matSuffix diameter="16" style="display: inline-flex"></mat-spinner>
                    </mat-form-field>
                    } @else {
                    <mat-form-field appearance="outline">
                        <mat-label>Instalment (Calculated)</mat-label>
                        <input matInput currencyMask formControlName="instalment" readonly>
                    </mat-form-field>
                    }
                </div>
                
                @if (!config.readMode && loanForm.valid && !loanForm.controls['instalment'].value) {
                <div class="flex-row flex-wrap">

                    <!-- Flex Spacer. -->
                    <div class="flex-1-auto"></div>

                    <!-- Try again button to calculate loan again. -->
                    <div class="flex-1-auto">
                        <button mat-raised-button color="accent" [disabled]="showLoanLoader" (click)="refreshInstalments()">
                            Calculate Installment <mat-icon>sync_problem</mat-icon>
                        </button>
                    </div>
                </div>
                }

            </form>

            <div class="stepper-controls">
                <button mat-stroked-button type="button"
                    [matTooltip]="loanForm.valid || isReadMode ? '' : 'Please complete the required fields.'"
                    (click)="loanForm.valid || isReadMode ? '' : markFormAtStepTouched()"
                    matStepperNext color="primary">
                    <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next
                </button>
                <button mat-stroked-button type="button" matStepperPrevious>
                    <mat-icon>arrow_back_ios</mat-icon> Back
                </button>
            </div>
            </ng-template>
        </mat-step>

        <mat-step [stepControl]="useFormStepperBypass ? fileStepperFormBypass : fileStepperForm" label="Documents" errorMessage="Missing documents." state="valid">
            <ng-template matStepContent>
            
            <div class="shift-left">

                <h2>Documents
                    <mat-icon [@fadeInOut] class="valid-icon" *ngIf="areFileFormsValid">check_circle</mat-icon>
                </h2>

                <lib-file-accordion (validityChanged)="updateFileFormsValidity($event);" 
                    [form]="form"
                    [stepperForm]="fileStepperForm"
                    [isReadMode]="isReadMode" 
                    [isCustomerAPatient]="isCustomerAPatient"
                ></lib-file-accordion>
            </div>

            <div class="stepper-controls">
                <button mat-stroked-button type="button"
                    [matTooltip]="fileStepperForm.valid || isReadMode ? '' : 'Required documents can be uploaded before submitting the application.'"
                    (click)="isReadMode ? '' : (fileStepperForm.valid ? markFormAtStepTouched() : stepOnInvalidForm())"
                    matStepperNext color="primary">
                    <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next
                </button>
                <button mat-stroked-button type="button" matStepperPrevious>
                    <mat-icon>arrow_back_ios</mat-icon> Back
                </button>
            </div>

            </ng-template>
        </mat-step>

        <mat-step [stepControl]="signatureStepperFrom" label="Sign Application" errorMessage="Signatures required."
            state="valid">
            <ng-template matStepContent>

            @if(signingMethod !== 0 && !isReadMode) {
            <div class="signing-step-controls">
                <button mat-stroked-button type="button" (click)="onSigningPageBack()"><mat-icon>arrow_back_ios_ios_new</mat-icon>Signing Options</button>
            </div>
            }
            
            @switch (signingMethod) {
                <!-- Electronic -->
                @case (1) {
                <div class="shift-left">
                    <h2>Sign Application
                        <mat-icon [@fadeInOut] class="valid-icon" *ngIf="areSignatureFormsValid">check_circle</mat-icon>
                    </h2>
                    <p>
                        Please read and sign each section below.<br>
                        A copy of the signed application will be made available to you.
                    </p>

                    <lib-signing-accordion 
                        (validityChanged)="updateSignatureFormsValidity($event);" 
                        [form]="form"
                        [invokeMarkDirty]="invokeMarkSignaturesDirty"
                        [isCustomerAPatient]="isCustomerAPatient"
                        [isReadMode]="isReadMode" 
                    ></lib-signing-accordion>
                </div>

                <div class="stepper-controls">
                    <button mat-stroked-button type="button"
                        [matTooltip]="isReadMode ? '' : (signatureStepperFrom.valid ? (fileStepperForm.valid ? '' : 'Mandatory documents are required to proceed.') : 'Please sign the required agreements.')"
                        (click)="signatureStepperFrom.valid || isReadMode ? '' : markFormAtStepTouched()"
                        [color]="fileStepperForm.valid ? null : 'warn'"
                        matStepperNext color="primary">
                        <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next
                    </button>
                    <button mat-stroked-button type="button" matStepperPrevious>
                        <mat-icon>arrow_back_ios</mat-icon> Back
                    </button>
                </div>
                }
                <!-- Manual -->
                @case (2) {
                <div class="shift-left">
                    <h2>Signing the Application
                        <mat-icon [@fadeInOut] class="valid-icon" *ngIf="areSignatureFormsValid">check_circle</mat-icon>
                    </h2>
                    <p class="ml-2">
                        1. Download the documents requiring signing, by clicking the download button below.
                    </p>
                    <p class="ml-2">
                        2. Print the documents and sign them.
                    </p>
                    <p class="ml-2">
                        3. Scan the signed documents and upload them by clicking the upload button below.
                    </p>

                    @if (!isReadMode) {
                    <div class="flex-center flex-column-at-600">
                        <button mat-raised-button color="primary" (click)="downloadSigningDocuments()">Download Documents</button>
                        <button mat-raised-button (click)="fileInput.click()">Upload Signed Documents</button>
                        <input type="file" #fileInput style="display: none" accept=".pdf" (change)="onUploadManualSignedDocument($event)">
                    </div>
                    }

                    @if (loanAgreementModel().filename && form.get('files')?.get('loanAgreement')?.value; as loanAgreement) {
                    <div class="flex-column-at-600 loan-agreement-container">
                        <p>{{loanAgreementModel().filename}} ({{loanAgreementModel().size}})</p>
                        
                        <lib-resource-viewer [showFullScreenBtn]="true" [showViewBtn]="true" [file]="loanAgreement"></lib-resource-viewer>
                    </div>
                    }
                </div>

                <div class="stepper-controls">
                    <button mat-stroked-button type="button"
                        [matTooltip]="isReadMode ? '' : (signatureStepperFrom.valid ? (fileStepperForm.valid ? '' : 'Mandatory documents are required to proceed.') : 'Please sign the required agreements and upload them.')"
                        (click)="signatureStepperFrom.valid || isReadMode ? '' : markFormAtStepTouched()"
                        [color]="fileStepperForm.valid ? null : 'warn'"
                        matStepperNext color="primary">
                        <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon> Next
                    </button>
                    <button mat-stroked-button type="button" matStepperPrevious>
                        <mat-icon>arrow_back_ios</mat-icon> Back
                    </button>
                </div>
                }
                @default {
                    <div class="signing-step-choice">

                        <p>How would you like to sign applications:</p>
        
                        <div class="signing-info">
                            <div class="signing-info-content">
        
                                <div class="signing-buttons">
                                    <button mat-raised-button color="primary" title="Sign the application electronically" (click)="setSignElectronically()">Sign Electronically</button>
                                    
                                    <button mat-raised-button title="Print the application, sign it and upload a scanned copy" (click)="setSignManually()">Print & Sign</button>
                                </div>
                                
                                <p>
                                    <strong>Electronic Signing:</strong> Sign the application electronically using the provided signing pad.
                                </p>
        
                                <p>
                                    <strong>Print & Sign:</strong> Print the application, sign it, and upload a scanned copy.
                                </p>
        
                                <p><i>Your selection will be remembered for the next application. This can be changed any time.</i></p>
                            </div>
                        </div>
                    </div>
                }
            }


            
            </ng-template>
        </mat-step>

        <mat-step label="Review" state="valid">
            <ng-template matStepContent>
            
            <p>
                Please ensure all details entered are accurate and correct. Any incorrect information may result in a
                delay in processing the application.
            </p>

            <mat-divider class="w-75 m-05-auto"></mat-divider>

            <h4>Customer: <strong>{{reviewModel().customer.title}}.
                {{reviewModel().customer.initials}} {{reviewModel().customer.lastName}}</strong></h4>

            <div class="reduced-margin bordered">
                <table>
                    <tr>
                        <th><span>ID Type:</span></th>
                        <td><span>{{reviewModel().customer.title}}</span></td>
                    </tr>
                    <tr>
                        <!-- <th><span>{{ displayModel().customer.idTitle }}:</span></th> -->
                        <th><span>ID No.:</span></th>
                        <td><span>{{ reviewModel().customer.identityNumber }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Full Name:</span></th>
                        <td><span>{{ reviewModel().customer.firstName }} {{ reviewModel().customer.lastName }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Email:</span></th>
                        <td><span>{{ reviewModel().customer.email }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Marital Status:</span></th>
                        <td><span>{{ reviewModel().customer.maritalStatus }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Mobile Number:</span></th>
                        <td><span>{{ reviewModel().customer.mobileNumber }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Address:</span></th>
                        <td><span>{{ reviewModel().customer.address ? reviewModel().customer.address + ', ': '' }} {{ reviewModel().customer.postalCode }}</span></td>
                    </tr>
                </table>
            </div>

            <mat-divider class="w-75 m-05-auto"></mat-divider>

            <h4>Employment Information</h4>

            <div class="reduced-margin bordered">
                <table>
                    <tr>
                        <th><span>Employer:</span></th>
                        <td><span>{{ reviewModel().employment.employer }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Branch Ph. Number:</span></th>
                        <td><span>{{ reviewModel().employment.branchPhone }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Job Title:</span></th>
                        <td><span>{{ reviewModel().employment.designation}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Employee Number:</span></th>
                        <td><span>{{ reviewModel().employment.employeeNumber }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Pay Cycle:</span></th>
                        <td><span>{{ reviewModel().employment.payCycle}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Pay Date:</span></th>
                        <td><span>{{reviewModel().employment.payDate}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Start Date:</span></th>
                        <td><span>{{reviewModel().employment.startDate | date:'dd/MM/yyyy'}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Address:</span></th>
                        <td><span>{{ reviewModel().employment.address ? reviewModel().employment.address + ',' : '' }}
                            {{ reviewModel().employment.postalCode }}</span></td>
                    </tr>
                </table>
            </div>

            <mat-divider class="w-75 m-05-auto"></mat-divider>

            <h4>Bank Information</h4>

            <div class="reduced-margin bordered">
                <table>
                    <tr>
                        <th><span>Bank:</span></th>
                        <td><span>{{ reviewModel().bankDetails.bank}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Branch Code:</span></th>
                        <td><span>{{ reviewModel().bankDetails.branchCode}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Account Type:</span></th>
                        <td><span>{{ reviewModel().bankDetails.accountType }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Account Number:</span></th>
                        <td><span>{{ reviewModel().bankDetails.accountNumber }}</span></td>
                    </tr>

                    @if (!isCustomerTheAccountHolder) {
                    <tr>
                        <th><span>Holder First Name:</span></th>
                        <td><span>{{ reviewModel().bankDetails.accountHolderFirstName }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Holder Last Name:</span></th>
                        <td><span>{{ reviewModel().bankDetails.accountHolderLastName }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Holder ID Type:</span></th>
                        <td><span>{{ reviewModel().bankDetails.accountHolderIdentityType }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Holder ID:</span></th>
                        <td><span>{{ reviewModel().bankDetails.accountHolderIdentityNumber }}</span></td>
                    </tr>
                    }
                </table>
            </div>

            <mat-divider class="w-75 m-05-auto"></mat-divider>

            <h4>Loan Information</h4>

            <div class="reduced-margin bordered">
                <table>
                    <tr>
                        <th><span>Amount:</span></th>
                        <td><span>{{ reviewModel().loan.loanAmount | number }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Initiation Fee:</span></th>
                        <td><span>R{{ reviewModel().loan.initiationFee | number}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Administration Fee:</span></th>
                        <td><span>R{{ reviewModel().loan.administrationFee | number}}</span></td>
                    </tr>
                    <tr>
                        <th><span>Instalment:</span></th>
                        <td><span>R{{ reviewModel().loan.instalment | number}}</span></td>
                    </tr>
                    <tr>
                        <th><span>No. of Installments:</span></th>
                        <td><span>{{ reviewModel().loan.instalments }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Start Date:</span></th>
                        <td><span>{{ reviewModel().loan.startDate | date:'dd/MM/yyyy'}}</span></td>
                    </tr>
                </table>
            </div>

            <mat-divider class="w-75 m-05-auto"></mat-divider>

            <h2>Patient(s) Information</h2>

            <!-- @for(patientForm of isCustomerAPatient ? patientsArray.controls : patientsArrayWithoutCustomer; track
            patientForm.value; let i = $index) { -->
            @for(patientForm of reviewModel().patients; track i; let i = $index) {

            <h4 class="mt-3 mb-0">Patient: <strong>{{ patientForm.title }} {{ patientForm.initials }} {{ patientForm.lastName }}
            </strong></h4>
            <div class="reduced-margin bordered">
                <table>
                    <tr>
                        <th><span>ID Type:</span></th>
                        <td><span>{{ patientForm.title }}</span></td>
                    </tr>
                    <tr>
                        <th><span>ID No.:</span></th>
                        <td><span>{{  patientForm.identityNumber }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Full Name:</span></th>
                        <td><span>{{ patientForm.firstName }} {{ patientForm.lastName }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Email:</span></th>
                        <td><span>{{ patientForm.email }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Marital Status:</span></th>
                        <td><span>{{ patientForm.maritalStatus }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Mobile Number:</span></th>
                        <td><span>{{ patientForm.mobileNumber }}</span></td>
                    </tr>
                    <tr>
                        <th><span>Address:</span></th>
                        <td><span>{{ patientForm.address ? patientForm.address + ',' : '' }} {{ patientForm.postalCode }}</span></td>
                    </tr>
                </table>
            </div>
            }

            <!-- <hr> -->
            <mat-divider class="w-75 m-05-auto"></mat-divider>

            @if (!isReadMode) {
            <mat-slide-toggle class="ml-3 mt-3" 
                [checked]="agreeReview" 
                [disabled]="isReadMode"
                color="primary"
                (change)="agreeReview = $event.checked"
                >I have reviewed the information and confirm it is correct.
            </mat-slide-toggle>
            }

            <div class="stepper-controls">
                <button mat-stroked-button type="button" matStepperPrevious>Back</button>
            </div>
            </ng-template>
        </mat-step>

        <!-- Icon overrides are done via the 'state' property. Only applied when state is not editing(first touch) and not errored. -->
        <ng-template matStepperIcon="valid">
            <mat-icon>check</mat-icon>
        </ng-template>
    </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <!-- Agent "created by" text. -->
    @if (agentName) {
    <span class="created-by-label"><div (click)=" isReadMode ? '' : changeAgent()" [ngClass]="{'hover-hand' : !isReadMode}">Created By <span>{{agentName | titlecase}}</span></div></span>
    }

    <!-- Editing controls. -->
    @if (!isReadMode) {
    <!-- Cancel button. -->
    <button type="button" mat-button color="warn" (click)="closeWithoutSaving()" [disabled]="form.disabled"
        matTooltip="Discard changes since the last save.">
        <mat-icon>cancel</mat-icon> Cancel</button>

    <!-- Save and close button. -->
    <button type="button" mat-button [disabled]="customerForm.invalid || isSubmitting || form.disabled"
        matTooltip="Invalid forms. Please complete before saving." [matTooltipDisabled]="form.valid"
        [color]="currentStep === 7 ? null : 'primary'"
        (click)="saveAndClose()">
        <mat-icon>save</mat-icon> Save & Close</button>
    } @else {
    <!-- Close button fo readonly mode. -->
    <button mat-button mat-dialog-close>Close</button>
    }

    <!-- Only available when the customer details and loan information are provided. -->
    <button type="button" mat-stroked-button [disabled]="customerForm.invalid || loanForm.invalid || isDownloadingQuote"
        (click)="onRequestQuote()">View Quote <mat-icon>request_quote</mat-icon></button>

    <!-- is not readmode, is on review step. -->
    @if (!isReadMode && currentStep === 7) {
    <!-- Submit button: Requires all validations to have passed and the user to have reviewed what they're creating. -->
    <button type="submit" mat-raised-button color="primary" type="submit"
        [matTooltip]="!maySubmit ? 'Please ensure all required information is supplied.' : agreeReview ? '' : 'Please check the review toggle.' "
        [disabled]="!maySubmit || !agreeReview || this.isSubmitting"
        (click)="onSubmit()">
        <mat-icon>check</mat-icon> Submit</button>
    }
</mat-dialog-actions>

<ng-template #patientsFormTemplate let-patientForm>
    <form [formGroup]="patientForm" class="mt-3">

        <div class="flex-row flex-wrap">
            <mat-form-field appearance="outline">
                <mat-label>ID Type</mat-label>
                @if (isReadMode) {
                <input matInput readonly [value]="toIdType(patientForm.get('identityType')?.value)">
                } @else {
                <mat-select formControlName="identityType" required
                    (selectionChange)="changeFocusToAndAnimation(patientIdInput);">
                    @for (opt of idTypeOptions; track opt.value) {
                    <mat-option [value]="opt.value">{{opt.display}}</mat-option>
                    }
                </mat-select>
                }
                
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>ID Field</mat-label>
                <input matInput [type]="patientForm.get('identityType')?.value === 1 ? 'number' : 'text'"
                    formControlName="identityNumber" [readonly]="isReadMode" #patientIdInput>
            </mat-form-field>
        </div>

        <div class="flex-row flex-wrap">
            <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                @if (isReadMode) {
                <input matInput readonly="true" [value]="toTitle(patientForm.get('title')?.value)">
                } @else {
                <mat-select formControlName="title">
                    @for (opt of titleOptions; track opt) {
                    <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                    }
                </mat-select>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Surname</mat-label>
                <input matInput formControlName="lastName" required [readonly]="isReadMode">
            </mat-form-field>
        </div>

        <div class="flex-row flex-wrap">
            <mat-form-field appearance="outline">
                <mat-label>Names</mat-label>
                <input matInput formControlName="firstName" required [readonly]="isReadMode">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Marital Status</mat-label>
                @if (isReadMode) {
                <input matInput readonly [value]="toMaterialStatus(patientForm.get('maritalStatus')?.value)">
                } @else {
                <mat-select formControlName="maritalStatus">
                    @for (status of maritalStatuses; track status.value) {
                    <mat-option [value]="status.value">{{ status.display }}</mat-option>
                    }
                </mat-select>
                }
            </mat-form-field>
        </div>

        <h3>Contact Information</h3>
        <div class="flex-row flex-wrap">

            <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input formControlName="mobileNumber" libPhoneFormat matInput placeholder="Formatting is automatic"
                    required type="tel" [control]="patientForm.controls['mobileNumber']" [readonly]="isReadMode">
                <mat-icon matSuffix>phone</mat-icon>
                <mat-hint>Format: +27 (xx) xxx-xxxx</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Email Address</mat-label>
                <input matInput type="email" formControlName="email" required [readonly]="isReadMode">
                <mat-icon matSuffix>mail</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Postal Code</mat-label>
                <input matInput formControlName="postalCode" [readonly]="isReadMode">
            </mat-form-field>
        </div>

        <div class="flex-row flex-wrap">
            <mat-form-field appearance="outline">
                <mat-label>Address</mat-label>
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6"
                    formControlName="address" [readonly]="isReadMode"></textarea>
            </mat-form-field>
        </div>

    </form>
</ng-template>
